import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { LoginChallengeDataService } from '../../../core/services/login-challenge-data.service';
import { Router } from '@angular/router';
import { AuthRoutes } from '../../models/routes/AuthRoutes.constant';
import { otpSendType } from './two-factor-login.config';
import { OtpInputComponent } from './otp-input/otp-input.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-two-factor-login',
    templateUrl: 'two-factor-login.component.html',
    styleUrls: ['two-factor-login.component.scss'],
    imports: [OtpInputComponent]
})
export class TwoFactorLoginComponent implements OnInit {

  public loginChallenge = '';
  public otpSession: string;
  public otpSendType: string;
  public otpSendTypeText = otpSendType;
  private destroyRef = inject(DestroyRef);

  constructor(private loginChallengeDataService: LoginChallengeDataService,
    private _router: Router) {
  }

  public ngOnInit() {
    this.loginChallenge = this.loginChallengeDataService.getLoginChallenge();
    this.loginChallengeDataService.loginChallengeSource
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this.onLoginCallengeChange.bind(this));
    this.otpSession= history.state.otpsession;
    this.otpSendType = history.state.otpType;
  }
  
  public goToLogin(): void {
    this._router.navigate([AuthRoutes.LOGIN], { queryParams: { login_challenge: this.loginChallenge } }); 
  }

  private onLoginCallengeChange(value: string): void {
    this.loginChallenge = value;
  }

}
